module.exports = __webpack_public_path__ + "img/31.83a8ef3f.svg";